/**
 * Formats a number to Indian numbering system with commas
 * Example: 9924290820 -> 9,92,42,90,820
 * First 3 digits from right, then every 2 digits
 */
export const formatIndianNumber = (num: number): string => {
  const absNum = Math.abs(num);
  const sign = num < 0 ? '-' : '';
  
  const numStr = Math.floor(absNum).toString();
  
  if (numStr.length <= 3) {
    return sign + numStr;
  }
  
  // Split into last 3 digits and remaining
  const lastThree = numStr.slice(-3);
  const remaining = numStr.slice(0, -3);
  
  // Add commas every 2 digits in the remaining part (from right to left)
  const formatted = remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
  
  return sign + formatted + ',' + lastThree;
};

/**
 * Format currency with Indian numbering and rupee symbol
 */
export const formatIndianCurrency = (amount: number): string => {
  return '₹' + formatIndianNumber(amount);
};
